/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { FieldMaker } from '@src/app/shared/field/FieldMaker';
import { FormConfig } from '@src/app/shared/form/FormConfig';
import { AbstractPageComponent } from '@src/app/shared/form/abstract-page.component';
import { FieldSet, LAYOUT_OPTIONS } from '@src/app/shared/form/field-set/field-set.component';
import { FormPageComponent } from '@src/app/shared/form/form-page/form-page.component';
import { required } from '@src/app/shared/validators';
import { FixedAssetType, FixedAssetTypeService } from '@src/app/modules/preventative/fixed-asset-type.service';
import { of } from 'rxjs';
import { FixedAssetTypePageNavRoute } from '@src/app/routes/app-router';

@Component({
    selector: 'app-fixed-asset-types-page',
    imports: [FormPageComponent],
    templateUrl: './fixed-asset-types-page.component.html',
    styleUrl: './fixed-asset-types-page.component.scss'
})
export class FixedAssetTypesPageComponent extends AbstractPageComponent {

    private dataSvc = inject(FixedAssetTypeService);

    config = new FormConfig({
        navRoute: FixedAssetTypePageNavRoute,
        docPath: 'omc-professional/fixed-asset-types',
        title: $localize`Fixed Asset Type`,
        fieldSet: new FieldSet({
            fields: [
                FieldMaker.id(),
                FieldMaker.rev(),
                FieldMaker.nameControl({ validators: [required] }),
                FieldMaker.notes()
            ],
            formLayout: LAYOUT_OPTIONS.singleCol,
        }),
        service: this.dataSvc,
        mode: 'list',
        objectFactory: () => of(new FixedAssetType()),
    });
}
